import { styled } from "@mui/material/styles";

export const EnquiryModalBackdrop = styled("div")({
  position: "fixed",
  inset: 0,
  background: "rgba(2,0,40,0.78)",
  backdropFilter: "blur(8px)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1300,
  padding: 24,
  animation: "mp-fade-in 200ms ease-out",
});

export const EnquiryModalPanel = styled("div")({
  position: "relative",
  background: "#0A0754",
  border: "1px solid rgba(255,255,255,0.12)",
  borderRadius: 20,
  width: "100%",
  maxWidth: 480,
  maxHeight: "92vh",
  overflowY: "auto",
  animation: "mp-slide-up 350ms cubic-bezier(0.16,1,0.3,1)",
});

export const EnquiryModalCloseBtn = styled("button")({
  position: "absolute",
  top: 16,
  right: 16,
  zIndex: 5,
  width: 36,
  height: 36,
  borderRadius: "50%",
  background: "rgba(0,0,0,0.5)",
  border: "1px solid rgba(255,255,255,0.2)",
  color: "#fff",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backdropFilter: "blur(8px)",
  fontFamily: "Poppins,sans-serif",
});

export const EnquiryModalHeader = styled("div")({
  padding: "32px 32px 24px",
  borderBottom: "1px solid rgba(255,255,255,0.08)",
});

export const EnquiryModalProgramTag = styled("span")({
  display: "inline-block",
  padding: "3px 10px",
  borderRadius: 999,
  background: "rgba(150,46,255,0.18)",
  border: "1px solid rgba(150,46,255,0.35)",
  color: "#D1C7FF",
  fontSize: 12,
  fontWeight: 500,
  fontFamily: "Poppins,sans-serif",
  marginBottom: 12,
});

export const EnquiryModalTitle = styled("h2")({
  margin: "0 0 8px",
  fontSize: 22,
  fontWeight: 700,
  color: "#FEFEFE",
  fontFamily: "Poppins,sans-serif",
  letterSpacing: "-0.01em",
});

export const EnquiryModalSubtitle = styled("p")({
  margin: 0,
  fontSize: 14,
  color: "#A87EFF",
  lineHeight: 1.55,
  fontFamily: "Poppins,sans-serif",
});

export const EnquiryModalBody = styled("div")({
  padding: "24px 32px 32px",

  "& form .fields-container": {
    display: "flex",
    flexDirection: "column",
    gap: 16,
    "& label": {
      marginBottom: "5px",
      display: "block",
      fontSize: "14px"
    }
  },
});

export const EnquiryModalActions = styled("div")({
  marginTop: 8,
});

export const EnquiryModalSubmitBtn = styled("button")({
  width: "100%",
  height: 50,
  borderRadius: 10,
  background: "linear-gradient(95deg,#01ECFF 0%,#6FFFFF 100%)",
  border: "none",
  color: "#030039",
  fontSize: 15,
  fontWeight: 600,
  fontFamily: "Poppins,sans-serif",
  cursor: "pointer",
  transition: "filter 200ms, transform 150ms",
  "&:hover:not(:disabled)": {
    filter: "brightness(1.1)",
    transform: "translateY(-1px)",
  },
  "&:disabled": {
    opacity: 0.6,
    cursor: "not-allowed",
  },
});

export const EnquiryModalSuccess = styled("div")({
  padding: "48px 32px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  gap: 12,
});

export const EnquiryModalSuccessTitle = styled("h3")({
  margin: 0,
  fontSize: 22,
  fontWeight: 700,
  color: "#FEFEFE",
  fontFamily: "Poppins,sans-serif",
});

export const EnquiryModalSuccessText = styled("p")({
  margin: 0,
  fontSize: 14,
  color: "#A87EFF",
  lineHeight: 1.6,
  fontFamily: "Poppins,sans-serif",
  maxWidth: 320,
});
